module.exports = __webpack_public_path__ + "static/img/office1.db563ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/office/office1.png
// module id = tJqz
// module chunks = 1